import axios from "axios";



const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (isLocalhost
    ? "http://localhost:8080"
    : "https://erp-api.sdcllp.co.in");
    
const HR_API_BASE_URL = `${API_BASE_URL}/api/hr`;

console.log("API_BASE_URL =", API_BASE_URL);
console.log("HR_API_BASE_URL =", HR_API_BASE_URL);

const recruitmentApi = axios.create({
  baseURL: HR_API_BASE_URL,
  timeout: 60000,
});
/* =========================================================
   REQUEST INTERCEPTOR
   Token automatically adds to every HR API request.
========================================================= */

recruitmentApi.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      sessionStorage.getItem("token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

/* =========================================================
   RESPONSE INTERCEPTOR
   Converts backend/network errors into readable messages.
========================================================= */

recruitmentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("HR API Error:", {
      message: error.message,
      method: error.config?.method,
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      fullURL: error.config
        ? `${error.config.baseURL || ""}${error.config.url || ""}`
        : "",
      status: error.response?.status,
      data: error.response?.data,
    });

    const backendMessage =
      error.response?.data?.message ||
      error.response?.data?.error;

    const isNetworkError =
      error.message === "Network Error" ||
      error.code === "ERR_NETWORK";

    const isTimeoutError =
      error.code === "ECONNABORTED" ||
      String(error.message || "")
        .toLowerCase()
        .includes("timeout");

    let message = "HR API request failed.";

    if (backendMessage) {
      message = backendMessage;
    } else if (isNetworkError) {
      message = `Backend is not reachable at ${HR_API_BASE_URL}`;
    } else if (isTimeoutError) {
      message = "HR API request timed out. Please try again.";
    } else if (error.message) {
      message = error.message;
    }

    return Promise.reject(new Error(message));
  },
);

/* =========================================================
   DASHBOARD
========================================================= */

export const getDashboard = (params = {}) =>
  recruitmentApi.get("/dashboard", {
    params,
  });

/* =========================================================
   JOB OPENINGS
========================================================= */

export const getJobOpenings = (params = {}) =>
  recruitmentApi.get("/job-openings", {
    params,
  });

export const createJobOpening = (data) =>
  recruitmentApi.post("/job-openings", data);

export const updateJobOpening = (id, data) => {
  if (!id) {
    return Promise.reject(
      new Error("Job opening ID is required."),
    );
  }

  return recruitmentApi.put(
    `/job-openings/${id}`,
    data,
  );
};

export const deleteJobOpening = (id) => {
  if (!id) {
    return Promise.reject(
      new Error("Job opening ID is required."),
    );
  }

  return recruitmentApi.delete(
    `/job-openings/${id}`,
  );
};

/* =========================================================
   CANDIDATES
========================================================= */

export const getCandidates = (params = {}) =>
  recruitmentApi.get("/candidates", {
    params,
  });

export const getCandidate = (id) => {
  if (!id) {
    return Promise.reject(
      new Error("Candidate ID is required."),
    );
  }

  return recruitmentApi.get(`/candidates/${id}`);
};

export const createCandidate = (data) =>
  recruitmentApi.post("/candidates", data);

export const updateCandidate = (id, data) => {
  if (!id) {
    return Promise.reject(
      new Error("Candidate ID is required."),
    );
  }

  return recruitmentApi.put(
    `/candidates/${id}`,
    data,
  );
};

export const deleteCandidate = (id) => {
  if (!id) {
    return Promise.reject(
      new Error("Candidate ID is required."),
    );
  }

  return recruitmentApi.delete(`/candidates/${id}`);
};

/* =========================================================
   INTERVIEWS
========================================================= */

export const getInterviews = (params = {}) =>
  recruitmentApi.get("/interviews", {
    params,
  });

export const getInterviewUsers = (params = {}) =>
  recruitmentApi.get("/interview-users", {
    params,
  });

export const createInterview = (data) =>
  recruitmentApi.post("/interviews", data);

export const updateInterview = (id, data) => {
  if (!id) {
    return Promise.reject(
      new Error("Interview ID is required."),
    );
  }

  return recruitmentApi.put(
    `/interviews/${id}`,
    data,
  );
};

export const deleteInterview = (id) => {
  if (!id) {
    return Promise.reject(
      new Error("Interview ID is required."),
    );
  }

  return recruitmentApi.delete(`/interviews/${id}`);
};

/* =========================================================
   OFFERS
========================================================= */

export const getOffers = (params = {}) =>
  recruitmentApi.get("/offers", {
    params,
  });

export const createOffer = (payload) =>
  recruitmentApi.post("/offers", payload);

export const updateOffer = (offerId, payload) => {
  if (!offerId) {
    return Promise.reject(
      new Error("Offer ID is required."),
    );
  }

  return recruitmentApi.put(
    `/offers/${offerId}`,
    payload,
  );
};

export const sendOfferLetter = (
  offerId,
  formData,
) => {
  if (!offerId) {
    return Promise.reject(
      new Error("Offer ID is required."),
    );
  }

  return recruitmentApi.post(
    `/offers/${offerId}/send`,
    formData,
    {
      timeout: 180000,
    },
  );
};

/* =========================================================
   DEFAULT EXPORT
========================================================= */

export default recruitmentApi;